<template>
  <best-seller />
  <index-profile />
  <index-meals />
  <user-reviews />
  <index-mapbox />
</template>

<script lang="ts" setup>
useSchemaOrg([
  defineLocalBusiness({
    name: "Resto App",
    url: "https://resto.hakobi-tech.com",
    image: "https://resto.hakobi-tech.com/images/burger.webp",
    address: {
      streetAddress: "123 Restaurant Street",
      addressLocality: "Metz",
      postalCode: "57000",
      addressCountry: "FR",
    },
    geo: {
      latitude: 48.6932648,
      longitude: 6.1829989,
    },
    telephone: "+33 1 23 45 67 89",
    openingHoursSpecification: {
      dayOfWeek: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
      opens: "11:00",
      closes: "22:00",
    },
    servesCuisine: ["Burgers", "Fast Food"],
    priceRange: "€€",
  }),
]);
</script>
